export enum MenuItemsIds {
    EXPORT = 'export',
    EXPORT_CSV = 'exportCsv',
    EXPORT_XLSX = 'exportXlsx',
    EXPORT_MARKDOWN = 'exportMarkdown',
    EXPORT_WIKI = 'exportWiki',
    EXPORT_SCREENSHOT = 'exportScreenshot',
    INSPECTOR = 'inspector',
    COMMENTS = 'comments',
    SHOW_COMMENTS = 'showComments',
    HIDE_COMMENTS = 'hideComments',
    SCREENSHOT = 'screenshot',
    NEW_WINDOW = 'openInNewWindow',
    OPEN_AS_TABLE = 'openAsTable',
    GET_LINK = 'getLink',
    SOURCE = 'source',
    EDIT = 'edit',
    COPY = 'copy',
    MOVE = 'move',
    RENAME = 'rename',
    DUPLICATE = 'duplicate',
    DELETE = 'delete',
    EMBEDDED = 'embedded',
    SETTINGS = 'settings',
    ALERTS = 'alerts',
    FULLSCREEEN = 'fullscreen',
}
